export default "__VITE_ASSET__20ZYEcSZ__"